import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWorkflowService } from 'interfaces-lib';
import { IFile } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { StandardWorkflowService, WorkflowTaskRunner } from 'workflow-task-service-lib';
import { environment } from '../../environments/environment';
import { AiResponseTask } from '../classes/ai-response-task';
import { IBullhornCardContext } from '../types/bullhorn-card-context';
import { IMessageHandlerComponent } from '../types/component-method-message-handler';
import { IEntitySourceData } from '../types/IEntitySourceData';
import { IPromptProfile } from '../types/prompt-profile';

@Injectable({
  providedIn: 'root',
})
export class AiPromptService {
  constructor(
    private http: HttpClient,
    private messageNotificationService: MessageNotificationService
  ) {}

  sendAiRequest(
    sourceDataV7: IEntitySourceData[],
    promptProfile: IPromptProfile,
    runParams: IRunParams,
    files: IFile[],
    fileDataOnly: boolean,
    notes: IEntitySourceData[],
    bullhornCardContext: IBullhornCardContext,
    parentComponentReference: IMessageHandlerComponent
  ) {
    const workflowService: IWorkflowService = new StandardWorkflowService(
      this.http,
      `${environment.kpWorkflowHost}`,
      environment.kpWorkflowStatus
    );
    if (!files) {
      files = [];
    }
    const taskRunner = new WorkflowTaskRunner(
      workflowService,
      new AiResponseTask(
        sourceDataV7,
        promptProfile,
        runParams,
        files,
        fileDataOnly,
        notes,
        bullhornCardContext,
        this.messageNotificationService,
        parentComponentReference
      )
    );
    taskRunner.run().subscribe({
      error: (error) =>
        this.messageNotificationService.error('The workflow could not be executed.', error),
    });
  }
}

export interface IRunParams {
  aiProvider: string | null;
  aiModel: string | null;
  temperature?: number | null;
}
